export default __webpack_public_path__ + "static/media/1818.08bf313a.png";